import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Button,
  Chip,
  Typography,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      paddingBottom: theme.spacing(2),
      borderBottom: '1px solid',
      gap: theme.spacing(1),
    },
    containerTitle: {
      gap: theme.spacing(1),
      flexWrap: 'wrap',
    },
    chips: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(0.5),
    },
    chip: { fontWeight: 500 },
    chipCritical: {
      backgroundColor: theme.palette.error.dark,
      color: theme.palette.primary.contrastText,
    },
    chipResolved: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText,
    },
    chipComments: {
      backgroundColor: theme.palette.info.light,
      color: theme.palette.primary.dark,
    },
    chipTotal: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    newNoteButton: {
      textTransform: 'none',
      gap: theme.spacing(1),
    },
    newNoteLabel: {
      textTransform: 'none',
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  })
);

const Header = ({ handleToogleOpen, notes }) => {
  const classes = useStyles();
  const { t } = useTranslation('orders');

  const list = notes ?? [];
  const total = list.length;
  const critical = list.filter((note) => note.critical && !note.resolved).length;
  const resolved = list.filter((note) => note.critical && note.resolved).length;
  const comments = list.filter((note) => !note.critical).length;

  const chips = [
    { key: 'critical', count: critical, label: t('criticalLabel'), className: classes.chipCritical },
    { key: 'comments', count: comments, label: t('commentsLabel'), className: classes.chipComments },
    { key: 'resolved', count: resolved, label: t('resolvedLabel'), className: classes.chipResolved },
    { key: 'total', count: total, label: t('totalLabel'), className: classes.chipTotal },
  ];

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      className={classes.container}
    >
      <Box display="flex" alignItems="center" className={classes.containerTitle}>
        <Typography variant="subtitle2">{t('orderNotesTitle')}</Typography>
        <Box className={classes.chips}>
          {chips.filter((chip) => chip.count > 0).map((chip) => (
            <Chip
              key={chip.key}
              size="small"
              className={clsx(classes.chip, chip.className)}
              label={`${chip.count} ${chip.label}`}
            />
          ))}
        </Box>
      </Box>
      <Button
        variant="contained"
        color="secondary"
        disableElevation
        className={classes.newNoteButton}
        aria-label={t('newNoteButton')}
        onClick={() => handleToogleOpen()}
      >
        <FontAwesomeIcon icon="plus" size="sm" />
        <Typography variant="subtitle2" className={classes.newNoteLabel}>
          {t('newNoteButton')}
        </Typography>
      </Button>
    </Box>
  );
};

export default Header;
